<template>
  <div id="expense-report" class="expense-account-page">
    <h2>📝 Expense Account Statement</h2>

    <div class="filter-bar">
      <label>From:</label>
      <input type="date" v-model="startDate" />
      <label>To:</label>
      <input type="date" v-model="endDate" />
      <button @click="fetchTransactions">🔍 Filter</button>
      <button @click="printReport">🖨 Print</button>
    </div>

    <div class="report-summary">
      <strong>Account:</strong> {{ account_id }}
      &nbsp; | &nbsp;
      <strong>Period:</strong> {{ startDate }} to {{ endDate }}
      &nbsp; | &nbsp;
      <strong>Total Expenses:</strong> ₦{{ formatAmount(totalExpenses) }}
    </div>

    <table class="transactions-table">
      <thead>
        <tr>
          <th>Date</th>
          <th>Description</th>
          <th>Type</th>
          <th>Amount (₦)</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="txn in transactions" :key="txn.id">
          <td>{{ formatDate(txn.created_at) }}</td>
          <td>{{ txn.description }}</td>
          <td>{{ txn.type }}</td>
          <td>{{ formatAmount(txn.amount) }}</td>
        </tr>
        <tr v-if="!transactions.length">
          <td colspan="4" class="no-data">
            No transactions found in selected period
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "ExpenseAccountReport",
  props: {
    account_id: {
      type: String,
      default: "EXP-001",
    },
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      transactions: [],
      totalExpenses: 0,
    };
  },
  methods: {
    fetchTransactions() {
      const dummyData = [
        {
          id: 1,
          created_at: "2025-06-01",
          description: "Stationery",
          type: "Debit",
          amount: 4500,
        },
        {
          id: 2,
          created_at: "2025-06-03",
          description: "Water Bill",
          type: "Debit",
          amount: 3000,
        },
        {
          id: 3,
          created_at: "2025-06-07",
          description: "Supplier Refund",
          type: "Credit",
          amount: 1500,
        },
        {
          id: 4,
          created_at: "2025-06-12",
          description: "Internet",
          type: "Debit",
          amount: 6500,
        },
        {
          id: 5,
          created_at: "2025-06-13",
          description: "Utility Refund",
          type: "Credit",
          amount: 2000,
        },
      ];

      this.transactions = dummyData.filter((txn) => {
        return (
          txn.created_at >= this.startDate && txn.created_at <= this.endDate
        );
      });

      this.calculateTotal();
    },
    calculateTotal() {
      this.totalExpenses = this.transactions
        .filter((t) => t.type === "Debit")
        .reduce((sum, t) => sum + Number(t.amount), 0);
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleDateString("en-CA");
    },
    formatAmount(value) {
      return Number(value).toLocaleString();
    },
    setCurrentMonthDates() {
      const today = new Date();
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

      this.startDate = firstDay.toISOString().split("T")[0];
      this.endDate = today.toISOString().split("T")[0];
    },
    printReport() {
      window.print();
    },
  },
  mounted() {
    this.setCurrentMonthDates();
    this.fetchTransactions();
  },
};
</script>

<style scoped>
.expense-account-page {
  padding: 20px;
  max-width: 900px;
  margin: 0 auto;
  font-family: sans-serif;
}

.filter-bar {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  align-items: center;
  flex-wrap: wrap;
}

.filter-bar input[type="date"] {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.filter-bar button {
  padding: 6px 12px;
  background: #2196f3;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.filter-bar button:hover {
  background: #1976d2;
}

.report-summary {
  margin-bottom: 15px;
  font-size: 15px;
  padding: 10px;
  background: #f4f4f4;
  border-left: 4px solid #2196f3;
}

.transactions-table {
  width: 100%;
  border-collapse: collapse;
}

.transactions-table th,
.transactions-table td {
  border: 1px solid #ddd;
  padding: 4px 6px;
  font-size: 13px;
}

.transactions-table th {
  background: #f0f0f0;
  text-align: left;
}

.transactions-table tr:nth-child(even) {
  background: #fafafa;
}

.transactions-table .no-data {
  text-align: center;
  padding: 10px;
  font-style: italic;
}

/* Print adjustments */
@media print {
  .filter-bar,
  button {
    display: none;
  }
  .expense-account-page {
    padding: 0;
    margin: 0;
  }
  .transactions-table th,
  .transactions-table td {
    padding: 3px 4px;
    font-size: 12px;
  }
}
</style>
